import React, {Component} from "react";
import styles from "editor/utilitybar/hints/Hints.module.scss";
import {Context} from "context";

export default class Hints extends Component {
    static contextType = Context;

    state = {
        hint: ""
    };

    moduleIsAvailable (path) {
        try {
            require.resolve(path);
            return true;
        } catch (e) {
            return false;
        }
    };

    componentDidMount() {
        window.addEventListener("mouseover", (event) => {
            const path = event.path || (event.composedPath && event.composedPath()); //get path event has travelled

            const hintElem = path.find(element => element.dataset?.hint); //find the deepest nested element in path with a hint

            this.setState({
                hint: hintElem?.dataset?.hint || ""
            })
        })
    }

    getIcon(groupName) {
        if (groupName !== "ungrouped") {
            if (this.moduleIsAvailable(`images/icons/${groupName.toLowerCase()}-dark.svg`)) {
                var viewIcon = require(`images/icons/${groupName.toLowerCase()}-dark.svg`);
                var viewIcon = require(`images/icons/folder${this.context.lightTheme ? "-light" : "-dark"}.svg`);
            } else {
                var viewIcon = require(`images/icons/folder${this.context.lightTheme ? "-light" : "-dark"}.svg`);
            }
        }
        return viewIcon;
    }

    makeSameFormatAsStyleSheet(groupName) {
        groupName = groupName.replace(/\s/g,'');
        groupName = groupName.replace('-','');
        groupName = groupName.replace('+','');
        return groupName;
    };

    render() {



        return (
            <div className={styles.info} data-hint={this.context.text.hints.hintBar}>
                <img src={require(`images/icons/info${this.context.lightTheme ? "-light" : "-dark"}.svg`)}/>
                <span>{this.state.hint}</span>
                <div className={`bgPrimary highlightSecondary ${styles.more}`}>
                    <div className={`bgSecondary highlightSecondary ${styles.shortcuts}`}>
                        <h3>Keyboard Shortcuts</h3>
                        {Object.entries(this.context.text.shortcuts).map(([_, {title, desc}]) => {
                            return (
                                <div>
                                    <span>{title}</span>
                                    <span>{desc}</span>
                                </div>
                            )
                        })}
                    </div>
                    <div className={`bgSecondary highlightSecondary ${styles.colours}`}>
                        <h3>Map Group Name Coding</h3>
                        {this.context.text.groupNames.map(groupName => {
                            return (
                                <div>
                                    <span className={`${styles.colour} ${this.makeSameFormatAsStyleSheet(groupName)}`}></span>
                                    <span>{groupName}</span>
                                    <img src={this.getIcon(groupName)}/>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        )
    }
}
